import { render } from "./SingleWorkout.vue?vue&type=template&id=3a2127c0&scoped=true"
import script from "./SingleWorkout.vue?vue&type=script&lang=js"
export * from "./SingleWorkout.vue?vue&type=script&lang=js"

import "./SingleWorkout.vue?vue&type=style&index=0&id=3a2127c0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2127c0"]])

export default __exports__